"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInputWithPath = void 0;
const isInputWithPath = (input) => {
    return input.path !== undefined;
};
exports.isInputWithPath = isInputWithPath;
